var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"action-input",attrs:{"disabled":_vm.disabled,"type":"text"},domProps:{"value":_vm.value},on:{"input":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }